<span
  class="item"
  [class.first]="isFirst"
  [class.selected]="isSelected"
  [class.bordered]="bordered"
>
  <span [class.with-notif]="nbNotifs > 0">
    <ng-content />
  </span>

  @if (nbNotifs > 0) {
    <span class="nb-notifs" [class.three-digits]="nbNotifs > 99">
      {{ nbNotifs < 100 ? nbNotifs : '99+' }}
    </span>
  }
</span>
